module.exports = __webpack_public_path__ + "img/img_logo_with_shadow.f5e91fde.png";